import { Entity } from '../../../../types/utility';
import { InceptHeader } from '../../../constants/InceptHeader';
import { ConstructPatch } from '../../../types/ConstructPatch';
import { NonPaginatedResponse } from '../../../types/NonPaginatedResponse';
import { APPLICATION_BASE_PATH } from '../constants/applicationBasePath';

export const patchApplicationBroker = async (
  constructPatch: ConstructPatch,
  uuid: string,
  definitionName: string,
  data: Entity,
): Promise<NonPaginatedResponse<Record<string, any>> | undefined> =>
  constructPatch(
    `${APPLICATION_BASE_PATH}/${uuid}/broker`,
    {
      data,
      headers: {
        [InceptHeader.DefinitionName]: definitionName,
      },
    },
    { preventDefaultErrorToast: true },
  );
